import React from 'react';
import { useSelector } from 'react-redux';
import DayPageShell from './DayPageShell';
import CrosswordGame from '../CrosswordGame';
import { s3PublicUrl } from '../../../utils/s3PublicUrl';

export default function Day3({ onStageComplete }) {
  const themeData = useSelector((state) => state.theme.data);
  const stage3 = themeData?.stages_data?.stage_3;
  const questions = stage3?.questions;
  const badgeUrl = s3PublicUrl(stage3?.badge);
  const pointsIconUrl = s3PublicUrl(themeData?.points_icon);
  const correctPoints = themeData?.correct_points ?? 0;
  const dayBonusPoints = themeData?.bonus_points ?? 0;

  const isConfigured =
    stage3 &&
    (stage3.type === 'crossword' || stage3.type === 'qa') &&
    Array.isArray(questions) &&
    questions.length > 0;

  return (
    <DayPageShell dayNumber={3} className="main-day-view--immersive">
      {!isConfigured ? (
        <p className="main-day-subtitle">
          Crossword is not configured: set stage_3 type &quot;crossword&quot; and questions with
          clue, answer, and did_you_know in the theme.
        </p>
      ) : (
        <CrosswordGame
          questions={questions}
          rules={stage3.rules}
          badgeUrl={badgeUrl}
          badgeTitle={String(stage3?.title ?? stage3?.name ?? 'Day 3')}
          questionImage={String(stage3?.question_image ?? '')}
          didYouKnowImage={String(stage3?.did_you_know_image ?? '')}
          correctPoints={correctPoints}
          dayBonusPoints={dayBonusPoints}
          pointsIconUrl={pointsIconUrl}
          badgeFallbackLabel="Day 3"
          onComplete={onStageComplete}
        />
      )}
    </DayPageShell>
  );
}
